import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import SelectField from '../../components/SelectField';
import User from '../../components/User';
import UserPickerItem from '../../../../plugins/MentionPickerPlugin/components/UserPickerItem';
var MAX_USERS_ON_EMPTY_QUERY = 10;
var TYPE_ITEM = 'type';

var DatabaseUsersField =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatabaseUsersField, _React$PureComponent);

  function DatabaseUsersField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DatabaseUsersField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DatabaseUsersField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onNewCellItem", function (user) {
      var _this$props = _this.props,
          recordKey = _this$props.record.key,
          columnKey = _this$props.column.key,
          database = _this$props.database;

      if (user.type === TYPE_ITEM) {
        return;
      }

      database.addUserToField(recordKey, columnKey, user);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveCellItem", function (item) {
      var _this$props2 = _this.props,
          recordKey = _this$props2.record.key,
          columnKey = _this$props2.column.key,
          database = _this$props2.database;
      database.removeUserFromField(recordKey, columnKey, item);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveUser", function (user) {
      var _this$props3 = _this.props,
          recordKey = _this$props3.record.key,
          columnKey = _this$props3.column.key,
          database = _this$props3.database;
      database.removeUserFromField(recordKey, columnKey, user);
    });

    _defineProperty(_assertThisInitialized(_this), "getUsersFromQuery", function _callee(query) {
      var _this$props4, recordKey, columnKey, database, users;

      return _regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props4 = _this.props, recordKey = _this$props4.record.key, columnKey = _this$props4.column.key, database = _this$props4.database;
              _context.next = 3;
              return _regeneratorRuntime.awrap(database.getUsersFromQuery(recordKey, columnKey, query, MAX_USERS_ON_EMPTY_QUERY));

            case 3:
              users = _context.sent;

              if (!query && users.length === MAX_USERS_ON_EMPTY_QUERY) {
                users.push({
                  type: TYPE_ITEM
                });
              }

              return _context.abrupt("return", users);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentUsers", function () {
      var _this$props5 = _this.props,
          recordKey = _this$props5.record.key,
          columnKey = _this$props5.column.key,
          database = _this$props5.database;
      return database.getFieldUsers(recordKey, columnKey);
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (user, index) {
      return {
        wrapperProps: {
          key: user.id
        },
        child: React.createElement(User, {
          name: user.username,
          onRemoveUser: function onRemoveUser() {
            return _this.onRemoveUser(user);
          },
          userId: user.id
        })
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderCellItem", function (options) {
      return options.type === TYPE_ITEM ? {
        child: React.createElement("div", {
          className: "width-full height-full shade-30 padding-normal",
          style: {
            cursor: 'default'
          }
        }, "+ start typing to find more people")
      } : {
        wrapperProps: {
          key: options.id
        },
        child: React.createElement(UserPickerItem, {
          user: options
        })
      };
    });

    return _this;
  }

  _createClass(DatabaseUsersField, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          attributes = _this$props6.attributes,
          isFocused = _this$props6.isFocused,
          database = _this$props6.database,
          store = _this$props6.store,
          column = _this$props6.column,
          record = _this$props6.record,
          isActive = _this$props6.isActive;
      return React.createElement(SelectField, Object.assign({}, attributes, {
        tooltipMessage: 'Add users',
        isFocused: isFocused,
        isActive: isActive,
        multiSelect: true,
        listItems: this.getCurrentUsers(),
        getCellItems: this.getUsersFromQuery,
        onNewCellItem: this.onNewCellItem,
        onRemoveCellItem: this.onRemoveCellItem,
        renderListItem: this.renderListItem,
        renderCellItem: this.renderCellItem,
        database: database,
        column: column,
        record: record,
        store: store
      }));
    }
  }]);

  return DatabaseUsersField;
}(React.PureComponent);

_defineProperty(DatabaseUsersField, "propTypes", {
  attributes: PropTypes.object,
  isFocused: PropTypes.bool,
  isActive: PropTypes.bool,
  record: PropTypes.object,
  column: PropTypes.object,
  field: PropTypes.object,
  database: PropTypes.object.isRequired,
  store: PropTypes.object
});

export { DatabaseUsersField as default };